module.exports = {
  siteTitle: 'The Hilltops Phoenix – Hilltops Region News and Current Affairs',
  siteTitleAlt: 'The Hilltops Phoenix', // This allows an alternative site title for SEO schema.
  publisher: 'The Hilltops Phoenix', // Organization name used for SEO schema
  siteDescription:
    'The Hilltops Phoenix – Your free weekly guide to what’s happening in and around The Hilltops.',
  siteUrl: 'https://www.hilltopsphoenix.com.au', // Site domain. Do not include a trailing slash! If you wish to use a path prefix you can read more about that here: https://www.gatsbyjs.org/docs/path-prefix/
  author: 'The Hilltops Phoenix', // Author for RSS author segment and SEO schema
  authorUrl: 'https://www.hilltopsphoenix.com.au/', // URL used for author and publisher schema, can be a social profile or other personal site
  userTwitter: '@twitter', // Change for Twitter Cards
  shortTitle: 'The Hilltops Phoenix', // Used for App manifest e.g. Mobile Home Screen
  shareImage: '/logos/share.jpg', // Open Graph Default Share Image. 1200x1200 is recommended
  shareImageWidth: 1200, // Change to the width of your default share image
  shareImageHeight: 1200, // Change to the height of your default share image
  siteLogo: '/logos/logo-512.png', // Logo used for SEO, RSS, and App manifest
  backgroundColor: '#ffffff', // Used for Offline Manifest
  themeColor: '#5d94cf', // Used for Offline Manifest
  copyright: 'Copyright © 2018 Roundbox Events', // Copyright string for the RSS feed
}
